module.exports = __webpack_public_path__ + "assets/img/crayon7.7297908d.png";